import React, { FC } from "react";

import { CloseButton } from "../../CloseButton/CloseButton";
import { BookingPricingSummary } from "../../BookingPricingSummary";
import ClickAwayListener from "react-click-away-listener";
import { useHandleClickAway } from "../../Hooks/useHandleClickAway";
import classNames from "classnames";
import { ServicePricingSummary } from "../../../../Partials/PricingHighlight/ServicePricingSummary.csharp";

type PricingSummaryModalProps = {
  onClose: () => void;
  isOpen: boolean;
  pricingSummary: ServicePricingSummary;
  Modal: any;
};

export const PricingSummaryModal: FC<PricingSummaryModalProps> = ({
  onClose,
  isOpen,
  pricingSummary,
  Modal,
}) => {
  const { handleMouseUp, handleMouseDown, handleClickAway, areaRef } =
    useHandleClickAway(onClose);

  return (
    <Modal
      overlayClassName="react-modal__overlay"
      className={classNames(
        "react-modal__content react-modal__content--additional",
        { "react-modal__content--opened": isOpen }
      )}
      isOpen={isOpen}
      shouldCloseOnEsc
      onRequestClose={onClose}
    >
      <div className="confirm-modal__outer">
        <ClickAwayListener onClickAway={handleClickAway}>
          <div
            className="confirm-modal__inner my-2 p-2 pt-1 fs-5"
            ref={areaRef}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
          >
            <CloseButton onClick={onClose} withWhiteBg />
            <h3 className="px-2 m-0">{pricingSummary.serviceName}</h3>
            <BookingPricingSummary hideHeading {...pricingSummary} />
          </div>
        </ClickAwayListener>
      </div>
    </Modal>
  );
};
